module.exports = __webpack_public_path__ + "static/img/bg.1d5863a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg.png
// module id = yRcn
// module chunks = 4